export default "__VITE_PUBLIC_ASSET__f96726f5__"